import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';

interface ContainmentFilterProps {
  filterIndex: number;
}

/**
 * Renders radio buttons for filtering sessions by containment status
 */
export const ContainmentFilter = ({ filterIndex }: ContainmentFilterProps) => {
  const { t } = useTranslation();
  const { control, getValues } = useFormContext();

  const { update } = useFieldArray({ control, name: 'filters' });

  const isContained = useWatch({ control, name: `filters.${filterIndex}.isContained` });

  const handleChange = (value: string) => {
    let booleanValue: boolean | null;
    if (value === 'true') {
      booleanValue = true;
    } else if (value === 'false') {
      booleanValue = false;
    } else {
      booleanValue = null; // 'all' option
    }
    const currentFilter = getValues(`filters.${filterIndex}`);
    update(filterIndex, { ...currentFilter, isContained: booleanValue });
  };

  return (
    <div className="space-y-3">
      <RadioGroup
        value={isContained?.toString() || ''}
        onValueChange={handleChange}
        className="gap-0"
      >
        <div className="flex items-center space-x-2 rounded-sm px-2 py-1.5 hover:bg-highlight-background">
          <RadioGroupItem value="true" id={`contained-true-${filterIndex}`} />
          <Label htmlFor={`contained-true-${filterIndex}`} className="cursor-pointer font-normal">
            {t('analytics.filters.onlyContainedConversations')}
          </Label>
        </div>
        <div className="flex items-center space-x-2 rounded-sm px-2 py-1.5 hover:bg-highlight-background">
          <RadioGroupItem value="false" id={`contained-false-${filterIndex}`} />
          <Label htmlFor={`contained-false-${filterIndex}`} className="cursor-pointer font-normal">
            {t('analytics.filters.hideContainedConversations')}
          </Label>
        </div>
      </RadioGroup>
    </div>
  );
};
